import { NONE_MATERIAL, OPTION_TYPE_HIDDEN_TEXT } from "common-code/lib/constants"
import { IOptionHiddenText } from "../../../../../../common-code/interfaces/option/IOptionHiddenText"
import {
    FURNITURE_CELL_BOX,
    FURNITURE_CELL_CORPUS, FURNITURE_CELL_FACADE, FURNITURE_CELL_OTHER,
    KIT_CODE_CHEAP,
    KIT_CODE_EXPENSIVE,
    KIT_CODE_MEDIUM
} from '../../../../../../common-code/constants';

export const facadeMaterials = {
    "aurora-gold-craft-oak" : "Золотой крафтовый дуб Aurora",
}


export const geometryTypes = {
    'square': "Прямоугольный",
    // 'arc': "Выпуклый",
    // 'concave': "Вогнутый"
}

export const sideTypes ={
    'default': "По умолчанию",
    'left': "Левая",
    'right': "Справа",
    'front': "Передняя",
    'back': "Задняя",
    'bottom': "Нижняя",
    'arc': "Дуговой",
    'top': "Верхний",
    'none': "Не открывается",
}

export const alignValues = {
    'left': "Слева",
    'right': "Справа",
    'top': "Сверху",
    'bottom': "Снизу",
    'center': "По центру"
}

export const facadeModeles = {
    'default': "Глухой",
    'decor': "Декор",
    'decor1': "Декор 1",
    'decor2': "Декор 2",
    // 'default+v': "По умолчанию по вертикали",
    'glass': "Витрина",
    'glass2': "Витрина 2 вид",
    // 'arc': "Выпуклый",
    // 'concave': "Вогнутый",
    'plane': "Плоский", 
    // 'warp': "Деформированный",
    'butil': "butil",
    // 'butil2': "butil2",
}

export const locations: {[key: string] : string}  = {
    'horizontal' : "Горизонтальная",
    'vertical' : "Вертикальная"
}


export const hingeAvailableKitCodes = {
    medium: "Комфорт",
    expensive: "Люкс",
}

export const legsPosition:{[key: string]: Record<string, string>}  = 
{
    "back-left": { x: "50", z: "50" },
    "front-left": { x: "=({%100}-50)", z: "50" },
    "front-right" : { x: "=({%100}-50)", z: "=({%100}-50)" },
    "back-right" : { x: "50", z: "=({%100}-50)" },
    "front-optional"   : { x: "=({%100}-50)", z: "=({%100}-50)" },
};


export const legsValues: Record<string, string>  = 
{
    "back-left": "Задняя левая",
    "front-left": "Задняя справа",
    "front-right" : "Передняя справа",
    "back-right" : "Передняя левая",
    "front-optional"   : "Передняя опциональная",
};

export const widthsValues= [
    { id: "300", title: "300 мм" },
    { id: "400", title: "400 мм" },
    { id: "450", title: "450 мм" },
    { id: "500", title: "500 мм" },
    { id: "600", title: "600 мм" },
]

export const corpusMaterial = {
    id: 'corpusMaterial',
    value: NONE_MATERIAL,
    sort: 1,
    title: 'материал корпуса',
    type: OPTION_TYPE_HIDDEN_TEXT,
} as IOptionHiddenText;

export const kitCodes = {
    [KIT_CODE_CHEAP]: "Стандарт",
    [KIT_CODE_MEDIUM]: "Комфорт",
    [KIT_CODE_EXPENSIVE]: "Люкс"
}
export const furnitureCells = {
    [FURNITURE_CELL_CORPUS]: 'Корпус',
    [FURNITURE_CELL_FACADE]: 'Фасад',
    [FURNITURE_CELL_BOX]: 'Ящик',
    [FURNITURE_CELL_OTHER]: 'Другое',
}